import { useShouldUseTeamsFocusNavigation } from '@ms/yammer-hooks/dist/teams';
import { ReturnFocusType, returnFocusHandler } from '@ms/yammer-web-support/dist/metaOsHub';
import type { FC, KeyboardEvent, PropsWithChildren } from 'react';
import React, { useCallback } from 'react';

const EscapeKeyNavigationHandler: FC<PropsWithChildren> = ({ children }) => {
  const shouldUseTeamsFocusNavigation = useShouldUseTeamsFocusNavigation();

  const keyDownHandler = useCallback((event: KeyboardEvent) => {
    if (event.code !== 'Escape') {
      return;
    }

    if (event.shiftKey || event.metaKey || event.ctrlKey) {
      return;
    }

    if (event.defaultPrevented) {
      return;
    }

    returnFocusHandler(ReturnFocusType.GoToActivityFeed);
  }, []);

  if (shouldUseTeamsFocusNavigation) {
    // oxlint-disable-next-line jsx-a11y/no-static-element-interactions
    return <div onKeyDown={keyDownHandler}>{children}</div>;
  }

  return <>{children}</>;
};

export default EscapeKeyNavigationHandler;
